module.exports = __webpack_public_path__ + "static/media/singha-online-logo.7c80552f.png";